import {useCallback, useEffect, useRef} from 'react';

const useInterval = (callback, interval = 1000) => {

    // save interval to ref to survive re-renders
    const intervalId = useRef(0);

    // save callback to ref
    const savedCallback = useRef(null);

    // update callback ref if callback func changes
    // This runs on every render to keep callback fresh
    useEffect(() => {
        savedCallback.current = callback;
    });

    const clear = useCallback(() => {
        clearInterval(intervalId.current);
    }, []);

    const start = useCallback(() => {
        clearInterval(intervalId.current);

        intervalId.current = setInterval(savedCallback.current, interval);
    }, [interval]);

    useEffect(() => {
        // If interval is null, don't start the interval
        if (interval === null || interval === undefined) {
            clearInterval(intervalId.current);
            return;
        }

        intervalId.current = setInterval(() => {
            savedCallback.current();
        }, interval);

        return () => {
            clearInterval(intervalId.current);
        };
    }, [interval]);

    return [clear, start];
};

export default useInterval;